import { NavLink } from 'react-router';
import { Package, Settings, Store, Truck } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Left navigation for the dashboard AppShell. Stripe-style: quiet,
 * mostly-neutral, indigo accent on the active item. Sections per
 * CLAUDE.md §10.1: Orders, plus dedicated Stores and Carriers areas
 * for managing connections, and Settings for cross-cutting config.
 */
interface NavItem {
  readonly to: string;
  readonly label: string;
  readonly icon: LucideIcon;
}

const NAV_ITEMS: readonly NavItem[] = [
  { to: '/app/orders', label: 'Orders', icon: Package },
  { to: '/app/stores', label: 'Stores', icon: Store },
  { to: '/app/carriers', label: 'Carriers', icon: Truck },
  { to: '/app/settings', label: 'Settings', icon: Settings },
];

export function Sidebar() {
  return (
    <aside className="border-border bg-background flex w-60 shrink-0 flex-col border-r">
      <div className="border-border flex h-14 items-center border-b px-6">
        <span className="text-foreground text-lg font-semibold tracking-tight">Mailchute.ai</span>
      </div>
      <nav className="flex flex-col gap-0.5 p-3" aria-label="Primary">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'hover:bg-muted flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive ? 'text-primary' : 'text-foreground',
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon
                  className={cn('size-5', isActive ? 'text-primary' : 'text-muted-foreground')}
                  aria-hidden="true"
                />
                {item.label}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
